import React from 'react';
import PropTypes from 'prop-types';
import { ChevronRightIcon as ArrowRightIcon } from '@domain-group/fe-co-icon';
import AllhomesListingCard, { AllhomesListingCardGraphQL } from '@domain-group/fe-co-allhomes-listing-card';
import * as styles from './allhomes-listing-more-listings.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AllhomesListingMoreListings = props => {
  var _props$items;
  return ___EmotionJSX(React.Fragment, null, (props.profileUrl || ((_props$items = props.items) === null || _props$items === void 0 ? void 0 : _props$items.length) > 0) && ___EmotionJSX("div", {
    css: styles.container
  }, ___EmotionJSX("h3", {
    css: styles.heading
  }, "More ", props.listingType, " listings from ", props.name), ___EmotionJSX("div", {
    css: styles.list
  }, props.items.map(item => ___EmotionJSX(AllhomesListingCardGraphQL, {
    css: styles.listItem,
    key: item.id,
    property: item,
    displayType: "default",
    includeStructuredData: false
  }))), props.profileUrl && ___EmotionJSX("a", {
    css: styles.link,
    href: props.profileUrl
  }, ___EmotionJSX("span", {
    css: styles.linkText
  }, "View all", ___EmotionJSX("span", {
    css: styles.linkTextName
  }, "\xA0", props.listingType, " listings for ", props.name)), ___EmotionJSX("span", null, ___EmotionJSX(ArrowRightIcon, {
    css: styles.linkIcon,
    size: "small"
  })))));
};
AllhomesListingMoreListings.propTypes = {
  name: PropTypes.string.isRequired,
  profileUrl: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape(AllhomesListingCard.propTypes)).isRequired,
  listingType: PropTypes.string.isRequired
};
export default AllhomesListingMoreListings;